'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryCommentEditor = require('./components/PrimaryCommentEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryCommentEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/primary-comment-editor/index.js
// module id = 1033
// module chunks = 4